export default __webpack_public_path__ + "static/media/game-map-cheng.dbabd932.jpg";